import { render, staticRenderFns } from "./UserReviews.vue?vue&type=template&id=09e9f060&"
import script from "./UserReviews.vue?vue&type=script&lang=js&"
export * from "./UserReviews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports